<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fa fa-image text-primary"></i> Banners</h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">File<sup><span class="text-danger font-12">*</span></sup> :</label>
          <label for="fileInput" class="attachment-icon" >
              <i class="fa fa-upload"></i>
            </label>
          <input class="form-control" id="fileInput" type="file" multiple accept=".png,.jpg,.jpeg,.webp,.pdf,.docx,.doc,.xls,.txt" @change="UploadImg" />
             <div class="d-flex align-items-start">
          <a v-if="Obj.Image" :href="Obj.Image" target="_blank"  class="clearfix">{{Obj.Image.substring(Obj.Image.lastIndexOf('/') + 1)  }} </a>
        </div></div>
      </div>
       <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
    </div>
  </div>
  <div v-if="Obj.Image">
    <div class="col-md-6 d-flex align-items-center mt-3 ms-auto mb-1 me-3">
    <i class="fas fa-download me-5 cursor-pointer" role="button"  @click="downloadImage"></i>
    </div>
    <div class="card shadow-sm border w-50 p-0 m-0" ref="printSection">
        <div class="d-flex align-items-center ps-2 py-1">
         <img :src="getUrl(profile?.Image)" alt="School Logo" class="me-2" width="60px" height="60px" /> 
          <h1 class="mb-0 fw-bold"> <span v-for="(word, index) in getNameWords()" :key="index" :class="bootstrapColors[index % bootstrapColors.length]" class="me-1" > {{ word }} </span></h1>
        </div>
        <div class="text-start p-0 m-0">
          <img :src="Obj.Image" alt="Banner Preview" class="img-fluid"/>
        </div>
       <div class="d-flex justify-content-between align-items-start mt-1 px-2">
        <p class=" fw-bold">{{ profile.Address }}</p>
        <p class="fw-bold text-nowrap">Contact : +91 {{ formattedMobileNo }}</p>
        </div>
        <div class="text-center px-2">
          <h5>Admissions are open for academic year {{ currentyear }}</h5>
        </div>
      </div>
      </div>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import html2canvas from 'html2canvas';
import { ref, computed} from 'vue'
 import { schoolStore } from '@/utils/schoolStore';
const { profile} = schoolStore();
const printSection = ref(null)
const  Obj = ref( {  Image: "", })
const   msgObj= ref({ msg: "", role: "", show: false, })
const   errors= ref({})
const bootstrapColors = [ 'text-danger', 'text-warning', 'text-success', 'text-primary', 'text-info', 'text-secondary', 'text-dark' ]
const getNameWords = () => {
  return profile?.value.Name ? profile.value.Name.split(' ') : [];
};
    const currentyear = computed(() => {
  const today = new Date();
  const month = today.getMonth(); 
  const year = today.getFullYear();
  if (month >= 5) { return `${year+1}-${year + 2}`; } 
  else { return `${year }-${year+1}`; }
});
const UploadImg = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  // validate allowed file types
  const allowed = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
  if (!allowed.includes(file.type)) {
    msgObj.value = { msg: "Only image files allowed", role: "danger", show: true };
    event.target.value = "";
    return;
  }

  // create local preview URL
  const imgUrl = URL.createObjectURL(file);
  Obj.value.Image = imgUrl;

  event.target.value = null; // reset input
};
  const formattedMobileNo = computed(() => {
  if (!profile.value?.MobileNo) return "";
  const num = profile.value.MobileNo.replace(/\D/g, "");
  return num.length === 10
    ? `${num.slice(0, 5)} ${num.slice(5)}`
    : profile.value.MobileNo; 
});
const downloadImage = async () => {
  const modalElement = printSection.value;
  if (!modalElement) return;
  const clone = modalElement.cloneNode(true);
  clone.style.padding = "0";
  clone.style.margin = "0";
  clone.style.border = "none";
  clone.style.boxShadow = "none";
  clone.style.background = "#fff";
  clone.style.width = "900px";
  clone.style.maxWidth = "900px";
  clone.style.position = "absolute";
  clone.style.left = "-9999px";
  clone.style.boxSizing = "border-box";
  clone.classList.remove("card", "shadow-sm", "border");
  document.body.appendChild(clone);
  try {
    const canvas = await html2canvas(clone, { 
    scale: 2, useCORS: true, backgroundColor: null, removeContainer: true, windowWidth: 900, });
    const imageData = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = imageData;
    link.download = "Banner.png";
    link.click();
  } finally {
    document.body.removeChild(clone);
  }
};

    const getUrl= (img)=> {
      let imgUrl = img.startsWith("..")
          ? img.substring(2)
          : img;  
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
    }
</script>